import React from "react";

import { TextConfirmationModal } from "src/base-components/TextConfirmationModal";
import { toastActions } from "src/design-system/Toast/utils";
import { useDeleteOutcomeType } from "src/outcomes/queries";
import { OutcomeType } from "src/outcomes/types";
import { logger } from "src/utils/logger";

type DeleteOutcomeTypeModalProps = {
  afterLeave: () => void;
  isOpen: boolean;
  onClose: () => void;
  outcomeType: OutcomeType | undefined;
};

const MIN_REPORTS_COUNT_TO_SHOW_TOAST = 100;

export const DeleteOutcomeTypeModal: React.FC<DeleteOutcomeTypeModalProps> = ({
  afterLeave,
  isOpen,
  onClose,
  outcomeType,
}) => {
  const { mutateAsync: deleteOutcomeType } = useDeleteOutcomeType();

  const handleDelete = async () => {
    if (!outcomeType) {
      return;
    }
    try {
      await deleteOutcomeType({
        id: outcomeType.id,
        flowId: outcomeType.flow_id,
      });

      if (
        outcomeType.count &&
        outcomeType.count > MIN_REPORTS_COUNT_TO_SHOW_TOAST
      ) {
        toastActions.success({
          title: "Outcome deletion has started",
          description: `${outcomeType.name} deletion has been started. It might take a while to complete.`,
        });
      }

      onClose();
    } catch (e) {
      toastActions.failure({
        title: "Failed to delete Outcome",
        description: "Please try again.",
      });
      logger.error(e);
    }
  };

  return (
    <TextConfirmationModal
      afterLeave={afterLeave}
      challengeText={outcomeType?.name}
      confirmButtonText="Delete Outcome"
      description="Are you sure you want to delete this Outcome? All existing Outcome data will be deleted. This change cannot be undone."
      label="Please enter the Outcome name to confirm"
      open={isOpen}
      title="Are you sure?"
      onClose={onClose}
      onConfirm={handleDelete}
    />
  );
};
